import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    drawer: {
        flexShrink: `0 !important`,
        "& .MuiDrawer-paper": {
            overflowY: "initial !important",
            boxSizing: "border-box !important",
        },
        "& .MuiList-root": {
            overflowY: "auto !important",
            height: "100%",
        },
    },
    drawerHeader: {
        position: "relative !important" as "relative",
        justifyContent: "flex-start !important",
        padding: "0 !important",
    },
    drawerHeaderIconButton: {
        position: "absolute !important" as "absolute",
        right: -10,
        width: `20px !important`,
        height: `20px !important`,
        color: `${theme.palette.primary.main} !important`,
        backgroundColor: `${theme.palette.info.main} !important`,
        padding: 0,
    },
    chevronIcon: {
        width: `16px !important`,
        height: `16px !important`,
    },
    drawerLogoWrapper: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
    },
    drawerLogo: {
        width: "100%",
        objectFit: "cover",
        height: 64,
    },
    drawerLogoText: {
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: 14,
        color: theme.palette.text.secondary,
        marginLeft: 8,
    },
    drawerItemIcon: {
        width: `24px !important`,
        height: `24px !important`,
        color: `${theme.palette.menu.icons.main} !important`,
    },
    drawerItem: {
        "& .MuiListItemIcon-root": {
            minWidth: `32px !important`,
        },
        "&:hover": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
            color: `${theme.palette.info.main} !important`,
        },
    },
    drawerItemText: {
        marginLeft: 4,
        "& span": {
            fontFamily: "Open Sans !important",
            fontWeight: "400 !important",
            fontSize: "14px !important",
            color: `${theme.palette.menu.icons.main} !important`,
        },
    },
    drawerItemTextNoData: {
        marginLeft: 4,
        "& span": {
            fontFamily: "Open Sans !important",
            fontWeight: "400 !important",
            fontSize: "14px !important",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    drawerItemSelected: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        color: `${theme.palette.info.main} !important`,
    },
    drawerFooter: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        padding: `0 0 ${theme.spacing(10)} 0`,
    },
    drawerFooterLogo: {
        width: 200,
    },
    loadingMenu: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px 0",
        width: "100%",
        fontFamily: "Open Sans !important",
        fontWeight: "400 !important",
        fontSize: "12px !important",
        color: `${theme.palette.primary.dark} !important`,
    },
    corporateEmptyImageWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 50,
        height: 50,
        borderRadius: "100%",
        backgroundColor: theme.palette.graphs.main,
    },
    drawerFooterItems: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
        width: "100%",
    },
    drawerDivider: {
        width: "100% !important",
    },
    drawerFooterWrapper: {
        width: "100%",
        marginBottom: theme.spacing(8),
    },
}));
